import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-version",
  "use": "icon-version-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-version\">\n  <defs>\n    <style>\n      #icon-version .cls-1 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n    </style>\n  </defs>\n  <path id=\"icon-version_i\" class=\"cls-1\" d=\"M1666,55a10,10,0,1,1,10-10A10,10,0,0,1,1666,55Zm0-18a8,8,0,1,0,8,8A8,8,0,0,0,1666,37Zm-1.78,14.023a2.792,2.792,0,0,1-.43-1.606,17.469,17.469,0,0,1,1.41-5.762l2.48-.518h0.12l-0.98,3.057a10.624,10.624,0,0,0-.61,2.705,0.918,0.918,0,0,0,.14.523,0.44,0.44,0,0,0,.36.2,1.309,1.309,0,0,0,.77-0.278,9.076,9.076,0,0,0,1.21-1.206v1.123c-1.52,1.6-2.66,2.4-3.41,2.4A1.259,1.259,0,0,1,1664.22,51.023Zm2.55-9.36a2.155,2.155,0,0,1-1.44-.508,7.064,7.064,0,0,0,.88-1.934,2.615,2.615,0,0,0,1.24.478,1.759,1.759,0,0,0,1.05-.381C1668.5,40.882,1667.92,41.663,1666.77,41.663Z\" transform=\"translate(-1656 -35)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/version.svg
// module id = uVf0
// module chunks = 32